<!--体验版-头部信息-->
<template>
  <div class="TopBar">
    <div class="experienceText">您当前访问的是体验版</div>
    <div class="title">
      <img class="logo" :src="logo_url" alt="logo">
      <h1 class="text">{{$store.state.currentServerInfo.title}}</h1>
    </div>
    <div class="HeadBarRight">
      <el-dropdown @command="handleCommand">
        <div class="el-dropdown-link flex">
          <img src="../../../../static/images/avater.png" alt=""><em>{{eUserInfo.user_name}}</em>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="modifyPassword">
            <i class="ico ico-my"></i>
            修改密码
          </el-dropdown-item>
          <el-dropdown-item command="loginSetting">
            <i class="ico ico-settings"></i>
            基本设置
          </el-dropdown-item>
          <el-dropdown-item command="loginOut" divided>
            <i class="ico ico-login"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
  import { eUserInfo } from "../../../../static/js/exp/config.js"
  import { showMsg, setLogoTitle, showToast } from "../../../../static/js/utility/utility.js"

  export default {
    name: 'CTopBar',
    data() {
      return {
        eUserInfo: eUserInfo,
        logo_url: ''
      }
    },
    mounted() {
      this.logo_url = '../../../../' + this.$store.state.currentServerInfo.logoUrl2
    },
    methods: {
      // 体验提示
      expShowMsg() {
        showMsg('体验环境下，该功能无法使用', 'warning')
      },
      // 点击下拉菜单list，点击执行相关操作
      handleCommand(command) {
        if (command === 'loginOut') {
          // 退出登录,清空缓存数据,跳转登录页
          localStorage.clear()
          sessionStorage.clear()
          setLogoTitle()
          this.$router.push({
            path: '/Exp/CLogin'
          })
        }else {
          this.expShowMsg()
        }
      }
    },
    watch: {
    }
  }
</script>

<style lang="scss" scoped>
$TopBarHeight: 140px;
.TopBar {
  height: $TopBarHeight;
  line-height: $TopBarHeight;
  // background-color: #fff;
  background: linear-gradient(to bottom right, #008ef2 , #096bf1);
  // box-shadow: 0 1px 4px rgba(0,21,41,.08);
  position: relative;
  z-index: 99;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 50px 70px 0 30px;
  box-sizing: border-box;
  .flex{
    height: 60px;
    display: flex;
    align-items: center;
  }
  .title{
    display: flex;
    align-items: center;
    .logo{
      width: 51px;
      img{ width: 100%; }
    }
    .text{
      font-size: 30px;
      color: #fff;
      margin-left: 15px;
    }
  }
  .switchIcon {
    float: left;
    height: $TopBarHeight;
    font-size: 20px;
    cursor: pointer;
    transition: all .3s,padding 0s;
    padding: 0 24px;
    i{
      font-size: 20px;
      line-height: $TopBarHeight;
    }
  }
  .HeadBarRight{
    height: 60px;
    display: flex;
    img{
      width: 60px;
      height: 60px;
    }
    em {
      font-size: 22px;
      color: #fff;
      text-decoration: underline;
      margin: 0 14px;
    }
  }
}
// 下拉菜单
.el-dropdown-menu {
  padding: 6px 0;
  .el-dropdown-menu__item {
    line-height: 35px;
  }
  // .el-dropdown-menu__item:nth-child(2){
  //   border-bottom: 1px solid #ebeef5;
  // }
  .el-dropdown-menu__item--divided {
    // margin-top: 4px;
    // border-top: none;
  }
  .el-dropdown-menu__item--divided:before {
    // height: 0;
  }
}

.experienceText {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color: #d2d3d6;
  background-color: #37435C;
  position: absolute;
  top:0;
  left: 0;
}


</style>



// WEBPACK FOOTER //
// src/components/ExpPage/Layout/CTopBar.vue